<template>
  <layout-register :step="step" :title-step="titlePage">
    <template #description-page>
      {{ $t('m42') }}
      <br />
      <br />
      {{ $t('m43') }}<strong>{{ $t('m44') }}</strong
      >{{ $t('m45') }}
    </template>
    <form @submit="sendDocument">
      <a-select-document
        :documents="documents"
        v-model="form.documentTypeId.value"
        :error="form.documentTypeId.error.length > 0"
        :errorMessage="form.documentTypeId.error"
      />

      <p
        class="mb-4"
        v-if="
          form.documentTypeId.value === '1' || form.documentTypeId.value === '2'
        "
      >
        <a-icon name="ic-password-lock" />
        <a role="button" tabindex="0" @click="modal = true">
          {{ $t('m46') }}
        </a>
      </p>
      <p class="mb-4" v-else-if="form.documentTypeId.value === '3'">
        <a-icon name="ic-password-lock" />
        <a role="button" tabindex="0" @click="modalPassport = true">
          {{ $t('m47') }}
        </a>
      </p>

      <div class="row">
        <div class="col-md-7 col-xs-12 col-sm-12 col-12">
          <a-btn
            class="next-step-button"
            primary
            type="submit"
            :loading="loadingBtn"
          >
            {{ $t('m48') }}
          </a-btn>
        </div>
      </div>
    </form>
    <a-modal
      class="modal-md"
      v-if="modalPassport"
      @close="modalPassport = false"
    >
      <h2 slot="header">
        {{ $t('m49') }}
      </h2>
      <div slot="body">
        <p>
          {{ $t('m50', { awto: $store.getters['visualResources/appName'] }) }}
        </p>
        <div class="intructions">
          <a-icon name="ic-data-1" />
          <p>
            {{ $t('m51') }}
          </p>
        </div>
        <div class="intructions">
          <a-icon name="ic-data-2" />
          <p>
            {{ $t('m52', { awto: $store.getters['visualResources/appName'] }) }}
          </p>
        </div>
        <div class="intructions">
          <a-icon name="ic-data-3" />
          <p>
            {{ $t('m53') }}
          </p>
        </div>
        <div class="intructions">
          <a-icon name="ic-data-4" />
          <p>
            {{ $t('m54') }}
          </p>
        </div>
        <h3>
          {{ $t('m55') }}
        </h3>
        <p>
          {{ $t('m56') }}
        </p>
      </div>
      <div slot="footer"></div>
    </a-modal>

    <a-modal class="modal-md" v-if="modal" @close="modal = false">
      <h2 slot="header">
        {{ $t('m57') }}
      </h2>
      <div slot="body">
        <p>
          {{ $t('m58') }}
        </p>
        <h3>
          {{ $t('m59') }}
        </h3>
        <p>
          {{ $t('m60') }}
          <br />
          <br />
          {{ $t('m61') }}
          <u>
            {{ $t('m62') }}
          </u>
          {{ $t('m63') }}
        </p>
        <h3>
          {{ $t('m64') }}
        </h3>
        <p>
          {{ $t('m65') }} <br />
          {{ $t('m66') }}
        </p>
        <h3>
          {{ $t('m67') }}
        </h3>
        <p>
          {{ $t('m68') }} <br />
          {{ $t('m69') }}
        </p>
        <h3>
          {{ $t('m70') }}
        </h3>
        <p>
          {{ $t('m71') }}
        </p>
      </div>
      <div slot="footer"></div>
    </a-modal>
  </layout-register>
</template>

<script>
import ABtn from '@/components/ui/ABtn';
import AIcon from '@/components/ui/AIcon';
import AModal from '@/components/ui/AModal';
import ASelectDocument from '@/components/ui/ASelectDocument';

import { validator } from '@/mixins/validator.js';

export default {
  name: 'Document',
  components: {
    AIcon,
    AModal,
    ABtn,
    ASelectDocument,
  },
  mixins: [validator],
  data() {
    return {
      documents: [],
      modal: false,
      loadingBtn: false,
      modalPassport: false,
      form: {
        documentTypeId: {
          value: '',
          error: '',
          rules: [],
        },
      },
      step: 3,
      titlePage: this.$t('m170'),
    };
  },
  created() {
    this.$store.dispatch('register/documentTypes').then(options => {
      this.documents = options;
    });
  },
  mounted() {
    this.form.documentTypeId.rules = [this.rules.required];
  },
  methods: {
    sendDocument(e) {
      if (this.validateForm()) {
        this.loadingBtn = true;
        this.$store
          .dispatch('register/document', {
            documentTypeId: this.form.documentTypeId.value,
          })
          .then(resp => {
            this.loadingBtn = false;
            if (resp.registrationStep) {
              this.$router.push({ name: resp.registrationStep });
            }
          });
      }
      e.preventDefault();
    },
  },
};
</script>
